module.exports = __webpack_public_path__ + "static/media/users-and-reviewers.da783f76.csv";